/*
 * ifshe Product Options — self-built personalization engine
 * Replaces the Cloudlift "Live Product Options" app (~5MB) with a few KB.
 *
 * Data-driven: reads a JSON config of fields from a product metafield
 * (custom.product_options_config), renders the controls, and enhances them
 * with conditional show/hide, required validation, a live up-charge total,
 * per-option price labels, and an in-circle PHOTO EDITOR (zoom / drag / rotate).
 *
 * Every control submits as a Shopify line item property: name="properties[<Label>]"
 * so the order data + fulfilment flow stay identical to the old app.
 *
 * Photo editor produces TWO things, mirroring the old app's order data:
 *   properties[image]    = the original uploaded file (factory needs the original)
 *   properties[_preview] = the adjusted square-with-circle render (what the customer set up)
 *   properties[_preview_params] = JSON {scale,rotate,x,y} as a redundant fallback
 *
 * Field schema (one object per field in the JSON array):
 *   { key, label, type, required, default, help, placeholder, maxlength,
 *     options:[{value, swatch?, upcharge?}], conditional:{field,equals} | {field,min},
 *       (min: shown while the controlling value starts with a number >= min, e.g. "3 Beads")
 *     editor:"photo", accept:"image/*" }
 *   type ∈ text | textarea | select | radio | swatch | file
 */
  // British spelling on the UK store (Beck 2026-06-09): word comes from the snippet's
  // data-pers-word; hostname fallback keeps this file a single shared source for both stores.
// Character-count hint, localized per store (same single-shared-source pattern as persWord).
function maxLabel(n) {
  var h = location.hostname;
  if (/\.de$/.test(h) || /^suiq6s-u3\./.test(h)) return " (max. " + n + " Zeichen)";
  if (/\.fr$/.test(h) || /^d1vzwt-i4\./.test(h)) return " (max. " + n + " caract\u00e8res)";
  return " (max " + n + " characters)";
}
function persWord(root) {
  return (root && root.dataset && root.dataset.persWord) ||
    (/\.co\.uk$/.test(location.hostname) ? "Personalisation" : "Personalization");
}

(function () {
  "use strict";
  var MOUNTED = "__ifshePoMounted";
  var TAU = Math.PI * 2;

  function money(n, currency) { return (currency || "$") + Number(n).toFixed(2); }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === "class") node.className = attrs[k];
      else if (k === "text") node.textContent = attrs[k];
      else if (k in node && k !== "list") { try { node[k] = attrs[k]; } catch (e) { node.setAttribute(k, attrs[k]); } }
      else node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) {
      if (c == null) return;
      node.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
    });
    return node;
  }

  // ---- Photo editor ----------------------------------------------------
  function buildPhotoEditor(field, name) {
    var fid = "po-file-" + (field.label || "image").replace(/\W+/g, "");
    var canvas = el("canvas", { class: "ifshe-po__editor-canvas", width: 360, height: 360 });
    var fileMain = el("input", { type: "file", id: fid, name: name,
      class: "ifshe-po__editor-file visually-hidden", accept: field.accept || "image/*" });
    var uploadBtn = el("label", { class: "ifshe-po__upload-btn", "for": fid }, [
      el("span", { class: "ifshe-po__upload-txt", text: "Upload Photo" })
    ]);
    // preview_key: per-field override so multiple photo editors on one product
    // don't collide on properties[_preview] / properties[_preview_params]
    var pkey = field.preview_key || "_preview";
    var filePrev = el("input", { type: "file", name: "properties[" + pkey + "]", class: "ifshe-po__editor-preview", tabindex: "-1" });
    filePrev.setAttribute("hidden", "");
    var paramsInput = el("input", { type: "hidden", name: "properties[" + pkey + "_params]", class: "js-po-params", value: "" });
    var tools = el("div", { class: "ifshe-po__editor-tools" }, [
      el("label", { class: "ifshe-po__tool" }, [
        el("span", { class: "ifshe-po__tool-icon", text: "−" }),
        el("input", { type: "range", class: "ifshe-po__range js-po-scale", min: "0.3", max: "4", step: "0.01", value: "1" }),
        el("span", { class: "ifshe-po__tool-icon", text: "+" })
      ]),
      el("div", { class: "ifshe-po__tool-btns" }, [
        el("button", { type: "button", class: "ifshe-po__tool-btn js-po-rotate", text: "⟳ Rotate" }),
        el("button", { type: "button", class: "ifshe-po__tool-btn js-po-reset", text: "Reset" })
      ])
    ]);
    return el("div", { class: "ifshe-po__editor", "data-editor": "photo", "data-shape": field.shape || "circle", "data-required": field.required ? "true" : "false" }, [
      el("div", { class: "ifshe-po__editor-stage" }, [canvas]),
      uploadBtn, fileMain,
      el("p", { class: "ifshe-po__editor-hint", text: "Upload, then drag to position · slider to zoom · rotate sideways photos" }),
      tools, filePrev, paramsInput
    ]);
  }

  // ---- crop shapes (per product: circle / oval / heart / square / rounded) ----
  function shapePath(c, shape, cx, cy, r) {
    if (shape === "oval") {
      // PORTRAIT oval matched to the real locket window (taller than wide, ~1.32 aspect)
      // — was landscape (1.18 x 0.82) which is the wrong orientation for the oval locket
      c.ellipse(cx, cy, r * 0.74, r * 0.98, 0, 0, TAU);
    } else if (shape === "square" || shape === "rounded") {
      var s = r * (shape === "rounded" ? 1.68 : 1.74), x = cx - s / 2, y = cy - s / 2, rad = shape === "rounded" ? s * 0.20 : 0;
      if (rad && c.roundRect) { c.roundRect(x, y, s, s, rad); }
      else { c.rect(x, y, s, s); }
    } else if (shape === "rect") {
      // landscape rounded rectangle — ID-plate photo window (wider than tall, ~1.4)
      var rw = r * 1.90, rh = rw / 1.40, rx = cx - rw / 2, ry = cy - rh / 2, rrad = rh * 0.16;
      if (c.roundRect) { c.roundRect(rx, ry, rw, rh, rrad); }
      else { c.rect(rx, ry, rw, rh); }
    } else if (shape === "rect-tall") {
      // portrait rounded rectangle — 3D crystal/glass photo block (taller than wide, ~1.4)
      var th = r * 1.90, tw = th / 1.40, tx = cx - tw / 2, ty = cy - th / 2, trad = tw * 0.16;
      if (c.roundRect) { c.roundRect(tx, ty, tw, th, trad); }
      else { c.rect(tx, ty, tw, th); }
    } else if (shape === "bar-tall") {
      // narrow portrait bar — vertical photo-etched bar pendant (39.5 x 10 mm blank,
      // ~1 : 3.6 usable photo area below the bail notch). NE80396801, 2026-07-28.
      var bh = r * 2.10, bw = bh / 3.6, bx = cx - bw / 2, by = cy - bh / 2, brad = bw * 0.18;
      if (c.roundRect) { c.roundRect(bx, by, bw, bh, brad); }
      else { c.rect(bx, by, bw, bh); }
    } else if (shape === "rect-2") {
      // tall rounded rectangle, 1 : 2 — dog-tag photo locket window (~22 x 45 mm). NE80450301, 2026-10-11.
      var dh = r * 2.00, dw = dh / 2.0, dx = cx - dw / 2, dy = cy - dh / 2, drad = dw * 0.24;
      if (c.roundRect) { c.roundRect(dx, dy, dw, dh, drad); }
      else { c.rect(dx, dy, dw, dh); }
    } else if (shape === "tag") {
      // dog tag photo face, 1 : 1.8 with dog-tag rounded corners (photo dog tags ~50 x 28 mm). 2026-10-11.
      var gh = r * 2.00, gw = gh / 1.8, gx = cx - gw / 2, gy = cy - gh / 2, grad = gw * 0.28;
      if (c.roundRect) { c.roundRect(gx, gy, gw, gh, grad); }
      else { c.rect(gx, gy, gw, gh); }
    } else if (shape === "heart-locket") {
      // traced from the real IFSHE heart locket silhouette (NE80446301 design v2,
      // Beck-approved 2026-07-09): aspect 0.97, widest at 30% height, 12% cleft,
      // rounded tip. Used by heart photo LOCKETS + photo BRACELETS; keyrings and
      // 3D crystal products keep the classic "heart" below.
      var hh = r * 1.9, hw = hh * 0.9717;
      var HX = function (u) { return cx + (u - 0.5) * hw; };
      var HY = function (v) { return cy + (v - 0.5) * hh; };
      c.moveTo(HX(0.5), HY(1.0));
      c.bezierCurveTo(HX(0.20), HY(0.72), HX(-0.01), HY(0.50), HX(0.0), HY(0.30));
      c.bezierCurveTo(HX(0.0), HY(0.02), HX(0.34), HY(-0.06), HX(0.5), HY(0.124));
      c.bezierCurveTo(HX(0.66), HY(-0.06), HX(1.0), HY(0.02), HX(1.0), HY(0.30));
      c.bezierCurveTo(HX(1.01), HY(0.50), HX(0.80), HY(0.72), HX(0.5), HY(1.0));
      c.closePath();
    } else if (shape === "heart-asym-l" || shape === "heart-asym-r") {
      // asymmetric sculptural heart traced from the real NE80417302 pendant frames
      // (2026-07-22, calibrated against the supplier open-locket photo): one big
      // round lobe, a lower opposite lobe, an off-centre tip and a long S-sweep.
      // -l = left frame (round lobe on the left), -r = mirrored right frame.
      var ah2 = r * 1.9, aw2 = ah2 * 0.82, mir = (shape === "heart-asym-r") ? -1 : 1;
      var GX = function (u) { return cx + mir * (u - 0.5) * aw2; };
      var GY = function (v) { return cy + (v - 0.5) * ah2; };
      c.moveTo(GX(0.45), GY(1.0));
      c.bezierCurveTo(GX(0.12), GY(0.74), GX(-0.03), GY(0.52), GX(0.01), GY(0.27));
      c.bezierCurveTo(GX(0.03), GY(0.0), GX(0.32), GY(-0.06), GX(0.58), GY(0.13));
      c.bezierCurveTo(GX(0.72), GY(0.0), GX(0.97), GY(0.06), GX(1.0), GY(0.30));
      c.bezierCurveTo(GX(0.99), GY(0.54), GX(0.74), GY(0.76), GX(0.45), GY(1.0));
      c.closePath();
    } else if (shape === "heart") {
      // plump, rounded heart matched to the real locket silhouette: domed lobes,
      // shallow cleft, ~1:1 aspect, soft bottom point (tuned 2026-06-06 against the product photo)
      var w = r * 0.98, t = cy - r * 0.50, cleft = cy - r * 0.42, b = cy + r * 0.92, lobe = r * 0.52, inx = 0.34;
      c.moveTo(cx, b);
      c.bezierCurveTo(cx - w * 0.55, cy + r * 0.34, cx - w, cy - r * 0.04, cx - w, t);
      c.bezierCurveTo(cx - w, t - lobe, cx - w * inx, t - lobe, cx, cleft);
      c.bezierCurveTo(cx + w * inx, t - lobe, cx + w, t - lobe, cx + w, t);
      c.bezierCurveTo(cx + w, cy - r * 0.04, cx + w * 0.55, cy + r * 0.34, cx, b);
      c.closePath();
    } else {
      c.arc(cx, cy, r, 0, TAU);
    }
  }
  function clipShape(c, shape, cx, cy, r) { c.beginPath(); shapePath(c, shape, cx, cy, r); c.clip(); }

  function setupPhotoEditor(editor) {
    var shape = editor.getAttribute("data-shape") || "circle";
    var canvas = editor.querySelector(".ifshe-po__editor-canvas");
    var ctx = canvas.getContext("2d");
    var W = canvas.width, H = canvas.height, R = Math.min(W, H) / 2 - 8;
    var fileMain = editor.querySelector(".ifshe-po__editor-file");
    var filePrev = editor.querySelector(".ifshe-po__editor-preview");
    var paramsInput = editor.querySelector('.js-po-params') || editor.querySelector('input[name="properties[_preview_params]"]');
    var range = editor.querySelector(".js-po-scale");
    var tools = editor.querySelector(".ifshe-po__editor-tools");
    var img = null, scale = 1, rot = 0, ox = 0, oy = 0;
    // 2026-10-28: no white gap is ever printed (#CH1016: a tall phone screenshot zoomed out -> white crescents
    // left/right in the factory preview). Beck chose "blur fill": the shopper may zoom out until the whole photo fits
    // the window; any uncovered part of the window shows the same photo, scaled to cover and heavily blurred
    // (downscale + upscale, works in every browser; no AI-generated content). If the blur cannot be built, the
    // editor falls back to "the photo must cover the window" so a gap still cannot happen.
    // The window's bounding box is measured once by rasterising shapePath (exact for every shape, incl. the
    // asymmetric hearts). Rotation is in 90-degree steps, so the photo stays axis-aligned.
    var ext = (function () {
      try {
        var mc = document.createElement("canvas"); mc.width = W; mc.height = H;
        var mx = mc.getContext("2d"); mx.beginPath(); shapePath(mx, shape, W / 2, H / 2, R); mx.fill();
        var px = mx.getImageData(0, 0, W, H).data, x0 = W, y0 = H, x1 = -1, y1 = -1;
        for (var yy = 0; yy < H; yy++) for (var xx = 0; xx < W; xx++) if (px[(yy * W + xx) * 4 + 3]) {
          if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
        if (x1 < 0) throw 0;
        return { l: W / 2 - x0 + 0.5, r: x1 + 1 - W / 2 + 0.5, t: H / 2 - y0 + 0.5, b: y1 + 1 - H / 2 + 0.5 };
      } catch (e) { return { l: W / 2, r: W / 2, t: H / 2, b: H / 2 }; }   // can't measure -> treat the whole canvas as the window
    })();
    var blurImg = null, blurFor = null;
    function blurOf() {                                 // tiny copy of the photo, smoothly upscaled = a soft blur
      if (blurFor === img) return blurImg;
      blurFor = img; blurImg = null;
      try {
        var cur = img, cw = img.width, ch = img.height;
        while (Math.max(cw, ch) > 48) {                 // halve step by step (one big jump aliases into noise)
          var nw = Math.max(1, Math.round(cw / 2)), nh = Math.max(1, Math.round(ch / 2));
          var hc = document.createElement("canvas"); hc.width = nw; hc.height = nh;
          var hx = hc.getContext("2d"); hx.imageSmoothingEnabled = true; hx.drawImage(cur, 0, 0, nw, nh);
          cur = hc; cw = nw; ch = nh;
        }
        var k = 16 / Math.max(cw, ch), tc = document.createElement("canvas");
        tc.width = Math.max(1, Math.round(cw * k)); tc.height = Math.max(1, Math.round(ch * k));
        tc.getContext("2d").drawImage(cur, 0, 0, tc.width, tc.height);
        var bc = document.createElement("canvas"); bc.width = tc.width * 8; bc.height = tc.height * 8;
        var bx = bc.getContext("2d"); bx.imageSmoothingEnabled = true; try { bx.imageSmoothingQuality = "high"; } catch (e0) {}
        bx.drawImage(tc, 0, 0, bc.width, bc.height);
        blurImg = bc;
      } catch (e) { blurImg = null; }
      return blurImg;
    }
    function dims() { return rot % 180 ? [img.height, img.width] : [img.width, img.height]; }
    function coverScale() { var d = dims(); return Math.max((ext.l + ext.r) / d[0], (ext.t + ext.b) / d[1]); }
    function minScale() { var d = dims(); return blurOf() ? Math.min((ext.l + ext.r) / d[0], (ext.t + ext.b) / d[1]) : coverScale(); }
    function paintBackdrop(c, f, w, h) {               // blurred photo covering the whole window, under the sharp photo
      var b = blurOf(); if (!b) return;
      var bs = coverScale() * 1.06 * f;
      c.save();
      c.translate(w / 2 + (ext.r - ext.l) / 2 * f, h / 2 + (ext.b - ext.t) / 2 * f);
      c.rotate(rot * Math.PI / 180);
      c.imageSmoothingEnabled = true; try { c.imageSmoothingQuality = "high"; } catch (e) {}
      c.drawImage(b, -img.width * bs / 2, -img.height * bs / 2, img.width * bs, img.height * bs);
      c.restore();
    }
    function clampPos() {                               // bigger than the window: must cover it; smaller: must stay inside it
      if (!img) return;
      var d = dims(), hw = d[0] * scale / 2, hh = d[1] * scale / 2;
      var a = ext.r - hw, b = hw - ext.l, p = ext.b - hh, q = hh - ext.t;
      ox = Math.min(Math.max(a, b), Math.max(Math.min(a, b), ox));
      oy = Math.min(Math.max(p, q), Math.max(Math.min(p, q), oy));
    }
    function clampAll() {
      if (!img) return;
      var m = minScale();
      if (!(scale >= m)) scale = m;
      range.min = String(m); range.max = String(Math.max(4, coverScale() * 4)); range.value = String(scale);
      clampPos();
    }
    tools.style.display = "none";

    function paintImage(c, size) {
      var f = size / W;                       // scale display(360) coords up to the export size
      var w = W * f, h = H * f, r = R * f;
      c.save();
      clipShape(c, shape, w / 2, h / 2, r);
      c.fillStyle = "#fff"; c.fillRect(0, 0, w, h);
      if (img) paintBackdrop(c, f, w, h);
      if (img) {
        c.translate(w / 2 + ox * f, h / 2 + oy * f);
        c.rotate(rot * Math.PI / 180);
        c.scale(scale * f, scale * f);
        c.drawImage(img, -img.width / 2, -img.height / 2);
      }
      c.restore();
    }
    function draw() {
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = "#f3ede4"; ctx.fillRect(0, 0, W, H);
      paintImage(ctx, W);
      // dim everything outside the shape so the crop is obvious
      ctx.save();
      ctx.fillStyle = "rgba(253,248,242,0.8)";
      ctx.beginPath(); ctx.rect(0, 0, W, H); shapePath(ctx, shape, W / 2, H / 2, R);
      ctx.fill("evenodd"); ctx.restore();
      ctx.beginPath(); shapePath(ctx, shape, W / 2, H / 2, R);
      ctx.lineWidth = 2; ctx.strokeStyle = "rgba(0,0,0,0.18)"; ctx.stroke();
      if (!img) {
        ctx.fillStyle = "#b3a99a"; ctx.textAlign = "center"; ctx.font = "14px sans-serif";
        ctx.fillText("Your photo preview", W / 2, H / 2);
      }
    }
    function fit() { scale = (R * 2) / Math.min(img.width, img.height); ox = 0; oy = 0; rot = 0; clampAll(); }

    // export the adjusted render to the hidden file input (so it travels with the order)
    function exportPreview() {
      if (!img) return;
      // export the adjusted preview at high resolution (so the projection art stays crisp)
      var EXP = Math.min(Math.max(img.naturalWidth || img.width, img.naturalHeight || img.height, 1200), 2000);
      var off = document.createElement("canvas"); off.width = EXP; off.height = EXP;
      var oc = off.getContext("2d"); if (!oc) return;   // 2026-09-10: no 2D context (canvas memory cap) -> leave _params empty, submit gate blocks
      paintImage(oc, EXP);
      paramsInput.value = JSON.stringify({ scale: +scale.toFixed(3), rotate: rot, x: Math.round(ox), y: Math.round(oy) });
      try {
        // JPEG instead of PNG: photographic content at 2000px is ~6MB as PNG vs ~0.5MB as JPEG
        // q0.92 (visually lossless for engraving/projection) — the upload wait was mostly this file.
        // paintImage fills a white background first, so no transparency is lost.
        var url = off.toDataURL("image/jpeg", 0.92);
        var bin = atob(url.split(",")[1]); var arr = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
        var dt = new DataTransfer();
        dt.items.add(new File([arr], "adjusted-preview.jpg", { type: "image/jpeg" }));
        filePrev.files = dt.files;
      } catch (e) { /* Safari w/o DataTransfer: params fallback still recorded */ }
    }
    var t; function schedExport() { clearTimeout(t); t = setTimeout(exportPreview, 180); }

    // 2026-09-10 (#DE1008, iPhone Firefox): the old path was FileReader -> data: URL -> Image with NO onerror,
    // and the "✓ Photo added" label was written BEFORE decoding. When Image.onload never fired, the original still
    // uploaded (native file input) but no preview / no _params reached the order — factory got photos, no crop.
    // Now: objectURL -> dataURL -> createImageBitmap, 20s per attempt, ✓ only after a real decode, and on total
    // failure the file is cleared + a visible message so the required-photo gate blocks the add.
    function decodeFile(f, done, failed) {
      var settled = false, timer = null;
      function finish(ok, im) { if (settled) return; settled = true; clearTimeout(timer); if (ok) done(im); else failed(); }
      function viaImage(src, revoke) {
        var im = new Image();
        im.onload = function () { if (revoke) { try { URL.revokeObjectURL(src); } catch (e) {} } if ((im.naturalWidth || im.width) > 0) finish(true, im); else next(); };
        im.onerror = function () { if (revoke) { try { URL.revokeObjectURL(src); } catch (e) {} } next(); };
        im.src = src;
      }
      var methods = [
        function () { if (!(window.URL && URL.createObjectURL)) return next(); var u; try { u = URL.createObjectURL(f); } catch (e) { return next(); } viaImage(u, true); },
        function () { var rd = new FileReader(); rd.onload = function (ev) { viaImage(ev.target.result, false); }; rd.onerror = function () { next(); }; try { rd.readAsDataURL(f); } catch (e) { next(); } },
        function () { if (!window.createImageBitmap) return next(); createImageBitmap(f).then(function (bm) { if (bm && bm.width > 0) finish(true, bm); else next(); }, function () { next(); }); }
      ];
      function next() { if (settled) return; clearTimeout(timer); var m = methods.shift(); if (!m) return finish(false); timer = setTimeout(next, 20000); m(); }
      next();
    }
    var decodeSeq = 0;
    fileMain.addEventListener("change", function (e) {
      var f = e.target.files && e.target.files[0]; if (!f) return;
      if (f.size > 20 * 1024 * 1024) { alert("That photo is larger than 20MB. Please choose a smaller image so it uploads correctly."); fileMain.value = ""; return; }
      var ut = editor.querySelector(".ifshe-po__upload-txt"); if (ut) ut.textContent = "Loading photo…";
      var oldErr = editor.querySelector(".ifshe-po__editor-error"); if (oldErr) oldErr.parentNode.removeChild(oldErr);
      img = null; paramsInput.value = ""; try { filePrev.value = ""; } catch (e0) {}
      var seq = ++decodeSeq;
      decodeFile(f, function (im) {
        if (seq !== decodeSeq) return;                 // a newer pick superseded this one
        img = im; fit(); tools.style.display = ""; draw(); exportPreview();
        if (ut) ut.textContent = "✓ Photo added — tap to change";
        var iw = im.naturalWidth || im.width, ih = im.naturalHeight || im.height;
        // Shrink oversized originals client-side: photo + high-res preview together must stay
        // under the ~20MB gateway limit or /cart/add.js returns an nginx 413 HTML page
        // ("Unexpected token '<' ... is not valid JSON"). 2400px is plenty for projection art.
        if (f.size > 3 * 1024 * 1024 || Math.max(iw, ih) > 2400) {
          var MAXD = 2400, sc = Math.min(1, MAXD / Math.max(iw, ih, 1));
          var dc = document.createElement("canvas");
          dc.width = Math.max(1, Math.round(iw * sc)); dc.height = Math.max(1, Math.round(ih * sc));
          var dctx = dc.getContext("2d"); if (!dctx) return;
          dctx.drawImage(im, 0, 0, dc.width, dc.height);
          dc.toBlob(function (b) {
            if (!b || b.size >= f.size) return; // keep original if re-encode didn't help
            try {
              var dtf = new DataTransfer();
              dtf.items.add(new File([b], (f.name || "photo").replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg" }));
              fileMain.files = dtf.files;
            } catch (err) { /* old Safari: original file stays; 20MB pre-guard still applies */ }
          }, "image/jpeg", 0.9);
        }
      }, function () {
        if (seq !== decodeSeq) return;
        img = null; paramsInput.value = ""; try { fileMain.value = ""; } catch (e1) {} draw();
        if (ut) ut.textContent = "Upload Photo";
        var errEl = el("p", { class: "ifshe-po__editor-error", role: "alert", text: "We couldn't read that photo in this browser. Please choose a JPG or PNG photo, or try again in Safari or Chrome." });
        errEl.style.cssText = "margin:8px 0 0;padding:10px 12px;background:#fff6f5;border:1px solid #f0c9c6;border-radius:8px;color:#b23b35;font-size:13px";
        editor.appendChild(errEl);
        if (window.console) console.error("[ifshe-po] photo decode failed", f.type, f.size, navigator.userAgent);
      });
    });
    range.addEventListener("input", function () { scale = parseFloat(range.value); clampAll(); draw(); schedExport(); });
    editor.querySelector(".js-po-rotate").addEventListener("click", function () { rot = (rot + 90) % 360; clampAll(); draw(); schedExport(); });
    editor.querySelector(".js-po-reset").addEventListener("click", function () { if (img) { fit(); draw(); schedExport(); } });

    var dragging = false, sx = 0, sy = 0;
    function pt(e) { var r = canvas.getBoundingClientRect(); var s = e.touches ? e.touches[0] : e;
      return { x: (s.clientX - r.left) * (W / r.width), y: (s.clientY - r.top) * (H / r.height) }; }
    canvas.addEventListener("mousedown", function (e) { if (!img) return; dragging = true; var p = pt(e); sx = p.x; sy = p.y; });
    window.addEventListener("mousemove", function (e) { if (!dragging) return; var p = pt(e); ox += p.x - sx; oy += p.y - sy; sx = p.x; sy = p.y; clampPos(); draw(); });
    window.addEventListener("mouseup", function () { if (dragging) { dragging = false; schedExport(); } });
    canvas.addEventListener("touchstart", function (e) { if (!img) return; dragging = true; var p = pt(e); sx = p.x; sy = p.y; }, { passive: true });
    canvas.addEventListener("touchmove", function (e) { if (!dragging) return; var p = pt(e); ox += p.x - sx; oy += p.y - sy; sx = p.x; sy = p.y; clampPos(); draw(); e.preventDefault(); }, { passive: false });
    canvas.addEventListener("touchend", function () { if (dragging) { dragging = false; schedExport(); } });

    editor._exportSync = exportPreview;
    editor._demo = function (url) { var im = new Image(); im.onload = function () { img = im; fit(); tools.style.display = ""; draw(); exportPreview(); }; im.src = url; };
    editor._state = function () { return { scale: +scale.toFixed(3), rot: rot, ox: Math.round(ox), oy: Math.round(oy), hasPreviewFile: !!(filePrev.files && filePrev.files.length), params: paramsInput.value }; };
    draw();
  }

  // ---- Field renderers -------------------------------------------------
  function renderField(field, root) {
    if (field.type === "intro") return el("p", { class: "ifshe-po__intro", text: field.text || "" });
    // field.key (when present) is the Shopify line-item property name sent to the factory;
    // field.label is purely the shopper-facing display. Falls back to label when no key.
    var name = "properties[" + (field.key || field.label) + "]";
    var wrap = el("div", { class: "ifshe-po__field ifshe-po__field--" + field.type, "data-field": field.label });
    if (field.field_upcharge) wrap.setAttribute("data-field-upcharge", field.field_upcharge);
    if (field.label) {
      var lab = el("label", { class: "ifshe-po__label", text: field.label });
      if (field.required) lab.appendChild(el("span", { class: "ifshe-po__req", text: " *" }));
      if ((field.type === "text" || field.type === "textarea") && field.maxlength) {
        lab.appendChild(el("span", { class: "ifshe-po__label-max", text: maxLabel(field.maxlength) }));
      }
      if (field.field_upcharge) lab.appendChild(el("span", { class: "ifshe-po__label-price", text: " +" + money(field.field_upcharge, root._currency) }));
      wrap.appendChild(lab);
    }
    if (field.help) wrap.appendChild(el("p", { class: "ifshe-po__help", text: field.help }));

    switch (field.type) {
      case "text":
        wrap.appendChild(el("input", { type: "text", name: name, class: "ifshe-po__input",
          placeholder: field.placeholder || "", maxlength: field.maxlength || 60, value: field.default || "", required: !!field.required }));
        break;
      case "textarea":
        wrap.appendChild(el("textarea", { name: name, class: "ifshe-po__input ifshe-po__textarea",
          placeholder: field.placeholder || "", maxlength: field.maxlength || 200, required: !!field.required, text: field.default || "" }));
        break;
      case "select":
        var sel = el("select", { name: name, class: "ifshe-po__input ifshe-po__select", required: !!field.required });
        // Required select with no preset default: prepend an empty placeholder so the browser
        // doesn't silently auto-select the first option (without it, a shopper could order e.g.
        // the smallest ring size having never opened the dropdown — OE-02 fix 2026-06-14).
        var hasDefault = (field.options || []).some(function (o) { return (field.default || "") === o.value; });
        if (field.required && !hasDefault) {
          sel.appendChild(el("option", { value: "", text: field.placeholder || ("Select " + (field.label || "an option")), selected: true, disabled: true }));
        }
        (field.options || []).forEach(function (o) {
          var opt = el("option", { value: o.value, text: (o.label || o.value) + (o.upcharge ? "  (+" + money(o.upcharge, root._currency) + ")" : "") });
          if (o.upcharge) opt.setAttribute("data-upcharge", o.upcharge);
          if ((field.default || "") === o.value) opt.selected = true;
          sel.appendChild(opt);
        });
        wrap.appendChild(sel);
        break;
      case "radio":
        var rg = el("div", { class: "ifshe-po__radios" });
        (field.options || []).forEach(function (o, i) {
          var id = "po-" + field.label.replace(/\W+/g, "") + "-" + i;
          var inp = el("input", { type: "radio", name: name, id: id, value: o.value, required: !!field.required });
          if ((field.default || "") === o.value) inp.checked = true;
          if (o.upcharge) inp.setAttribute("data-upcharge", o.upcharge);
          rg.appendChild(el("label", { class: "ifshe-po__radio", "for": id }, [
            inp, el("span", { text: o.label || o.value }),
            o.upcharge ? el("span", { class: "ifshe-po__price-tag", text: "+" + money(o.upcharge, root._currency) }) : null
          ]));
        });
        wrap.appendChild(rg);
        break;
      case "swatch":
        var sw = el("div", { class: "ifshe-po__swatches", role: "radiogroup" });
        // no auto-pick of the first option: birthstones must be chosen by the shopper
        var hidden = el("input", { type: "hidden", name: name, value: field.default || "" });
        if (field.required) hidden.setAttribute("data-po-required", "true");
        (field.options || []).forEach(function (o) {
          var active = hidden.value === o.value;
          var kids = [el("span", { class: "ifshe-po__swatch-dot", style: "background:" + (o.swatch || "#ccc") })];
          if (o.upcharge) kids.push(el("span", { class: "ifshe-po__swatch-badge", text: "+" + money(o.upcharge, root._currency) }));
          kids.push(el("span", { class: "ifshe-po__swatch-cap", text: o.label || o.value }));
          var btn = el("button", { type: "button", class: "ifshe-po__swatch" + (active ? " is-active" : ""), title: o.value, "data-value": o.value }, kids);
          if (o.upcharge) btn.setAttribute("data-upcharge", o.upcharge);
          btn.addEventListener("click", function () {
            hidden.value = o.value;
            sw.querySelectorAll(".ifshe-po__swatch").forEach(function (b) { b.classList.remove("is-active"); });
            btn.classList.add("is-active"); recalc(root);
          });
          sw.appendChild(btn);
        });
        wrap.appendChild(sw); wrap.appendChild(hidden);
        break;
      case "image":
        var ig = el("div", { class: "ifshe-po__image-opts", role: "radiogroup" });
        var hiddenI = el("input", { type: "hidden", name: name, value: field.default || (field.options[0] && field.options[0].value) || "" });
        (field.options || []).forEach(function (o) {
          var media = el("span", { class: "ifshe-po__image-opt-media" }, [
            o.image ? el("img", { src: o.image, alt: o.value, loading: "lazy" }) : el("span", { class: "ifshe-po__image-opt-emoji", text: o.emoji || "📦" })
          ]);
          var label = el("span", { class: "ifshe-po__image-opt-label" }, [
            el("span", { class: "ifshe-po__image-opt-name", text: o.label || o.value }),
            el("span", { class: "ifshe-po__image-opt-price", text: o.upcharge ? "+" + money(o.upcharge, root._currency) : "Free" })
          ]);
          var kids = [media, label];
          if (o.caption) kids.push(el("span", { class: "ifshe-po__image-opt-cap", text: o.caption }));
          var card = el("button", { type: "button", class: "ifshe-po__image-opt" + (hiddenI.value === o.value ? " is-active" : ""), "data-value": o.value }, kids);
          if (o.upcharge) card.setAttribute("data-upcharge", o.upcharge);
          card.addEventListener("click", function () {
            hiddenI.value = o.value;
            ig.querySelectorAll(".ifshe-po__image-opt").forEach(function (b) { b.classList.remove("is-active"); });
            card.classList.add("is-active"); recalc(root);
            // conditional fields keyed on an image option (e.g. Pattern -> its own engraving lines).
            // Image cards set a hidden input, which fires no change event by itself. 2026-10-11 NE80450301
            hiddenI.dispatchEvent(new Event("change"));
          });
          ig.appendChild(card);
        });
        wrap.appendChild(ig); wrap.appendChild(hiddenI);
        break;
      case "file":
        if (field.editor === "photo") wrap.appendChild(buildPhotoEditor(field, name));
        else {
          var pfid = "po-file-" + field.label.replace(/\W+/g, "");
          wrap.appendChild(el("label", { class: "ifshe-po__upload-btn", "for": pfid }, [el("span", { text: "Upload File" })]));
          wrap.appendChild(el("input", { type: "file", id: pfid, name: name, class: "ifshe-po__file visually-hidden", accept: field.accept || "image/*", required: !!field.required }));
          wrap.appendChild(el("p", { class: "ifshe-po__file-note", text: "JPG/PNG · uploaded securely with your order" }));
        }
        break;
    }
    return wrap;
  }

  // ---- Up-charge total -------------------------------------------------
  function recalc(root) {
    var total = 0;
    root.querySelectorAll("[data-upcharge]").forEach(function (node) {
      var on = node.tagName === "OPTION" ? node.selected
        : node.type === "radio" ? node.checked
        : (node.classList.contains("ifshe-po__swatch") || node.classList.contains("ifshe-po__image-opt")) ? node.classList.contains("is-active") : false;
      if (on) total += parseFloat(node.getAttribute("data-upcharge")) || 0;
    });
    // field-level up-charge (e.g. extra birthstone +$1 — charged once when any value is chosen)
    root.querySelectorAll("[data-field-upcharge]").forEach(function (fe) {
      if (fe.style.display === "none") return;
      var hid = fe.querySelector('input[name^="properties"]');
      if (hid && hid.value && String(hid.value).trim()) total += parseFloat(fe.getAttribute("data-field-upcharge")) || 0;
    });
    var base = parseFloat(root.dataset.basePrice || "0") || 0;
    var up = root.querySelector(".ifshe-po__up-amt"), tot = root.querySelector(".ifshe-po__total-amt");
    if (up) up.textContent = total > 0 ? "+" + money(total, root._currency) : money(0, root._currency);
    if (tot) tot.textContent = money(base + total, root._currency);
    // 加价合计为 0 时整块隐藏：礼盒之类的唯一加价项也会让 hasUpcharge=true，于是给没有任何
    // 个性化字段的产品渲染出「Personalization $0.00 / Total」——纯噪音（Beck 2026-08-11 抓 ER024650）
    var pr = root.querySelector(".ifshe-po__pricing");
    if (pr) pr.style.display = total > 0 ? "" : "none";
    var hid = root.querySelector('input[name="properties[_options_price]"]');
    if (hid) hid.value = total.toFixed(2);
  }

  // ---- Conditional show/hide ------------------------------------------
  function applyConditions(root, fields) {
    fields.forEach(function (f) {
      if (!f.conditional) return;
      var target = root.querySelector('.ifshe-po__field[data-field="' + f.label + '"]');
      if (!target) return;
      var radios = root.querySelectorAll('[name="properties[' + f.conditional.field + ']"]');
      var single = root.querySelector('[name="properties[' + f.conditional.field + ']"]');
      function read() {
        if (radios.length && radios[0].type === "radio") {
          var c = root.querySelector('[name="properties[' + f.conditional.field + ']"]:checked');
          return c ? c.value : "";
        }
        return single ? single.value : "";
      }
      function update() {
        // 2026-10-18: conditional.min — a count option ("3 Beads", "4 Stones") reveals groups 2..N only, so a cheaper
        // count can't carry extra paid groups (hidden fields are disabled: not submitted, not validated). No choice yet -> hidden.
        var v = read();
        var show = f.conditional.min != null ? parseInt(v, 10) >= f.conditional.min : v === f.conditional.equals;
        target.style.display = show ? "" : "none";
        target.querySelectorAll("input,select,textarea").forEach(function (i) { i.disabled = !show; });
        var grp = target.parentNode;   // a group card whose fields are all hidden hides with its title ("Person 3")
        if (grp && grp.classList && grp.classList.contains("ifshe-po__group")) {
          grp.style.display = Array.prototype.some.call(grp.querySelectorAll(".ifshe-po__field"), function (x) { return x.style.display !== "none"; }) ? "" : "none";
        }
      }
      radios.forEach(function (r) { r.addEventListener("change", update); });
      if (single) single.addEventListener("change", update);
      update();
    });
  }

  // ---- AJAX add-to-cart with an up-charge fee line --------------------
  // The store is on Shopify Basic (no Cart Transform), so the up-charge is a separate hidden
  // "product-options" line: a fee-tier variant priced at the total x item qty when one exists
  // (2026-11-03), else the 0.01 variant x cents (e.g. 21.99 -> qty 2199). See CLAUDE.md contract.
  function currentUpcharge(root) {
    var hid = root.querySelector('input[name="properties[_options_price]"]');
    return hid ? (parseFloat(hid.value) || 0) : 0;
  }
  function feeBreakdown(root) {
    // list each chosen paid option as "Field = X.XX USD" (mirrors old order data)
    var props = {};
    root.querySelectorAll("[data-upcharge]").forEach(function (node) {
      var on = node.tagName === "OPTION" ? node.selected
        : node.type === "radio" ? node.checked
        : (node.classList.contains("ifshe-po__swatch") || node.classList.contains("ifshe-po__image-opt")) ? node.classList.contains("is-active") : false;
      if (!on) return;
      var amt = parseFloat(node.getAttribute("data-upcharge")) || 0;
      if (amt <= 0) return;
      var fieldEl = node.closest(".ifshe-po__field");
      var label = (fieldEl && fieldEl.getAttribute("data-field")) || "Option";
      props[label] = amt.toFixed(2) + " " + (root.dataset.currencyCode || "USD");
    });
    // OE-05: field-level up-charges (Text on Ring +$10, extra birthstone +$5, …) are charged when
    // the field has a value but were missing from this breakdown — so the cart "add-ons" detail
    // didn't sum to the amount actually charged. Include them so detail matches the fee total.
    root.querySelectorAll("[data-field-upcharge]").forEach(function (fe) {
      if (fe.style.display === "none") return;
      var amt = parseFloat(fe.getAttribute("data-field-upcharge")) || 0;
      if (amt <= 0) return;
      var hid = fe.querySelector('input[name^="properties"]');
      if (hid && hid.value && String(hid.value).trim()) {
        props[fe.getAttribute("data-field") || "Option"] = amt.toFixed(2) + " " + (root.dataset.currencyCode || "USD");
      }
    });
    return props;
  }
  // 2026-10-15 (Beck): on non-English stores the shopper saw the factory's English option value in the cart,
  // checkout, emails and order page (e.g. "Gaveæske: No"). Send the shopper-facing label instead and keep the
  // English value in a hidden "_<name>" property: hidden from customers, still shown in the admin for the factory.
  // English stores, text/file fields and options whose label equals the value are sent exactly as before.
  function localizeChoiceValues(root, fd) {
    if (/^en\b/i.test(document.documentElement.lang || "en")) return;
    var done = {};
    (root._poFields || []).forEach(function (f) {
      if (["select", "radio", "swatch", "image"].indexOf(f.type) < 0) return;
      var pname = f.key || f.label;
      if (!pname || done[pname]) return;
      var wrap = null;
      root.querySelectorAll(".ifshe-po__field").forEach(function (w) { if (!wrap && w.getAttribute("data-field") === f.label) wrap = w; });
      if (!wrap || wrap.style.display === "none") return;          // conditionally hidden -> disabled, not submitted
      var key = "properties[" + pname + "]";
      var v = fd.get(key);
      if (typeof v !== "string" || !v) return;
      var o = (f.options || []).filter(function (x) { return x.value === v; })[0];
      if (!o || !o.label || o.label === v) return;
      fd.set(key, o.label);
      fd.append("properties[_" + pname + "]", v);
      done[pname] = true;
    });
  }
  function submitWithFee(form, root) {
    var btn = form.querySelector('[name="add"], button[type="submit"], input[type="submit"]');
    var btnTxt = btn && (btn.querySelector("span") || btn);
    if (btn) { btn.disabled = true; btn.setAttribute("aria-busy", "true"); btn.classList.add("ifshe-po-busy");
      if (btnTxt) { btnTxt.dataset.poLabel = btnTxt.textContent; btnTxt.textContent = "Adding\u2026"; } }
    // quantity input may live outside the <form> (form="…" attribute) -> form.elements sees it, querySelector doesn't
    var qtyInput = (form.elements && form.elements.namedItem && form.elements.namedItem("quantity")) || form.querySelector('[name="quantity"]');
    var mainQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var upcharge = currentUpcharge(root);
    var feeVariant = parseInt(root.dataset.feeVariant || "0", 10);
    var needFee = upcharge > 0;
    // 2026-11-03 fee tiers: a "product-options" variant priced exactly at this total -> qty = item count
    // (checkout shows 1, not 1500). No tier -> legacy 0.01 x cents. Keys = total in cents.
    var feeCents = Math.round(upcharge * 100);
    var feeTiers = {};
    try { feeTiers = JSON.parse(root.dataset.feeTiers || "{}") || {}; } catch (e) { feeTiers = {}; }
    var tierVariant = parseInt(feeTiers[String(feeCents)] || "0", 10) || 0;
    var oid = "po-" + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

    var fd = new FormData(form);          // keeps the photo file (multipart -> Shopify CDN)
    localizeChoiceValues(root, fd);
    fd.append("properties[_options_id]", oid);

    function fail(err) {
      if (btn) { btn.disabled = false; btn.removeAttribute("aria-busy"); btn.classList.remove("ifshe-po-busy");
        var bt = btn.querySelector("span") || btn; if (bt.dataset.poLabel) bt.textContent = bt.dataset.poLabel; }
      var nt = root.querySelector(".ifshe-po__notice");
      // only surface Shopify's own description; raw JS errors (e.g. JSON parse of an HTML 413 page) stay in console
      var msg = (err && err.description) || "Sorry, we couldn't add this to your cart. Please try again.";
      if (nt) { nt.textContent = msg; nt.style.display = "block"; nt.scrollIntoView({ behavior: "smooth", block: "center" }); }
      if (window.console) console.error("[ifshe-po] add-to-cart failed", err);
    }

    // CFP-02: a paid option is selected but the $0.01 fee placeholder variant is missing
    // (placeholder product deleted / unpublished / variant id changed). Block BEFORE adding
    // anything — never silently sell a paid-options item at base price (site-wide under-charge).
    if (needFee && !feeVariant && !tierVariant) {
      if (window.console) console.error("[ifshe-po] fee variant missing while up-charge>0 — blocking add to avoid undercharge");
      fail({ description: "Sorry, this item can't be added right now — please refresh and try again, or contact us." });
      return;
    }

    fetch("/cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (mainItem) {
        if (!needFee) return null;                          // no paid options -> main line only
        var props = feeBreakdown(root);
        props["_options_id"] = oid;
        props["_options_fee"] = "1";
        if (mainItem && mainItem.quantity) mainQty = mainItem.quantity;   // what Shopify actually added
        var expectFee = feeCents * mainQty;            // what the fee line(s) must total, in cents
        var strict = root.dataset.feeStrict === "1";   // shop currency only: converted prices can't be checked to the cent
        function jpost(url, body) {
          return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) })
            .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
        }
        function lineCents(it) { return (it.original_price != null ? it.original_price : it.price) * it.quantity; }
        // add one fee line and check what Shopify actually priced it at; a wrong line is removed again
        function addFee(id, qty) {
          return jpost("/cart/add.js", { id: id, quantity: qty, properties: props }).then(function (j) {
            if (strict && j && j.key && lineCents(j) !== expectFee) {
              if (window.console) console.error("[ifshe-po] fee line priced " + lineCents(j) + " != " + expectFee + " — removing it");
              return jpost("/cart/change.js", { id: j.key, quantity: 0 }).catch(function () {})
                .then(function () { throw { feeMismatch: true }; });
            }
            return j;
          });
        }
        function addLegacy() {
          if (!feeVariant) return Promise.reject({ description: "Sorry, this item can't be added right now — please refresh and try again, or contact us." });
          return addFee(feeVariant, expectFee);
        }
        var feeAdd = !tierVariant ? addLegacy() : addFee(tierVariant, mainQty).catch(function (tierErr) {
          if (window.console) console.warn("[ifshe-po] fee tier add failed, falling back to 0.01 line", tierErr);
          // never charge twice: if a fee line for this item did land (lost response) and is right, keep it;
          // anything else for this item is cleared before the 0.01 fallback
          return fetch("/cart.js", { headers: { "Accept": "application/json" } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var mine = (cart.items || []).filter(function (it) {
                return it.properties && it.properties._options_id === oid && it.properties._options_fee === "1";
              });
              var got = mine.reduce(function (a, it) { return a + lineCents(it); }, 0);
              if (mine.length === 1 && got === expectFee) return null;
              var upd = {}; mine.forEach(function (it) { upd[it.key] = 0; });
              return (mine.length ? jpost("/cart/update.js", { updates: upd }) : Promise.resolve()).then(addLegacy);
            });
        });
        return feeAdd
          .catch(function (feeErr) {
            // CFP-01: the main item is already in the cart but the fee line failed. Roll the main
            // item back so we NEVER leave a "paid options, base price" order (silent under-charge)
            // or a duplicate on retry. Re-throw so the shopper gets a clear try-again message.
            var rollback = (mainItem && mainItem.key)
              ? fetch("/cart/change.js", {
                  method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
                  body: JSON.stringify({ id: mainItem.key, quantity: 0 })
                }).catch(function () {})
              : Promise.resolve();
            return rollback.then(function () { throw feeErr; });
          });
      })
      .then(function () { window.location.href = "/cart"; })
      .catch(fail);
  }

  // ---- Required validation + export editors on submit -----------------
  function setupValidation(root) {
    var form = root.closest("form");
    if (!form) return;
    // photo upload needs multipart; Shopify's product form is urlencoded by default
    form.setAttribute("enctype", "multipart/form-data");
    // 2026-09-19: novalidate — hidden required fields in the collapsed panel made the browser abort submit silently
    // before the handler below ran (first add-to-cart click did nothing). The handler validates every required control itself.
    form.setAttribute("novalidate", "novalidate");
    form.addEventListener("submit", function (e) {
      root.querySelectorAll('.ifshe-po__editor').forEach(function (ed) { if (ed._exportSync) { try { ed._exportSync(); } catch (err) { if (window.console) console.error("[ifshe-po] export failed", err); } } });
      // not opened yet → expand. If the product has REQUIRED personalization, block this first
      // add-to-cart so the shopper completes it. If everything is OPTIONAL, just expand and let the
      // add proceed on this same click — no pointless second click (OE-08).
      if (root.classList.contains("is-collapsed")) {
        root.classList.remove("is-collapsed");
        var tg = root.querySelector(".ifshe-po__toggle");
        if (tg) { tg.setAttribute("aria-expanded", "true"); var tt = tg.querySelector(".ifshe-po__toggle-txt"); if (tt) tt.textContent = root.dataset.toggleClose || ("Remove " + persWord(root)); }
        var hasRequired = root.querySelector('[required], [data-po-required="true"], .ifshe-po__editor[data-required="true"]');
        if (hasRequired) {
          var nt = root.querySelector(".ifshe-po__notice"); if (nt) { nt.textContent = "Please complete your personalization before adding to cart."; nt.style.display = "block"; }
          e.preventDefault(); e.stopPropagation(); root.scrollIntoView({ behavior: "smooth", block: "center" });
          return;
        }
        // optional-only: fall through to the validation + submit path below (adds on this click)
      }
      var bad = null;
      root.querySelectorAll("[required]").forEach(function (i) {
        if (i.disabled) return;
        var ok = i.type === "radio" ? !!root.querySelector('[name="' + i.name + '"]:checked') : !!(i.value && i.value.trim());
        if (!ok && !bad) bad = i;
      });
      // swatch / image-option required: hidden input, not natively validated
      root.querySelectorAll('[data-po-required="true"]').forEach(function (h) {
        if (h.disabled || bad) return;
        if (!(h.value && String(h.value).trim())) {
          var fe = h.closest(".ifshe-po__field");
          bad = (fe && fe.querySelector(".ifshe-po__swatches, .ifshe-po__image-opts")) || h;
        }
      });
      root.querySelectorAll('.ifshe-po__editor[data-required="true"]').forEach(function (ed) {
        var fm = ed.querySelector(".ifshe-po__editor-file");
        if (!fm || fm.disabled) return;
        if (!fm.files || !fm.files.length) { if (!bad) bad = ed; }
      });
      // 2026-09-10 (#DE1008): a photo that was picked but never decoded/exported would reach the order with no
      // crop preview and empty _params. Never let that through silently — block and ask for a re-upload.
      root.querySelectorAll('.ifshe-po__editor').forEach(function (ed) {
        if (bad) return;
        var fm = ed.querySelector(".ifshe-po__editor-file"), pp = ed.querySelector(".js-po-params");
        if (fm && !fm.disabled && fm.files && fm.files.length && pp && !(pp.value && pp.value.trim())) {
          bad = ed;
          var ntp = root.querySelector(".ifshe-po__notice");
          if (ntp) { ntp.textContent = "Your photo preview isn't ready yet. Please upload the photo again (JPG or PNG) before adding to cart."; ntp.style.display = "block"; }
          if (window.console) console.error("[ifshe-po] blocked add: photo present but no preview/params");
        }
      });
      if (bad) {
        e.preventDefault(); e.stopPropagation();
        var fe = bad.closest(".ifshe-po__field"); if (fe) fe.classList.add("ifshe-po__field--error");
        bad.scrollIntoView({ behavior: "smooth", block: "center" }); if (bad.focus) bad.focus();
        return;
      }
      // validation passed -> take over add-to-cart so we can append the fee line
      e.preventDefault(); e.stopPropagation();
      submitWithFee(form, root);
    }, true);
  }

  // ---- Mount -----------------------------------------------------------
  // OE-01: the add button ships disabled+data-po-gate for products with personalization;
  // enabling it here proves the engine ran. If this JS never loads, the button stays disabled
  // so a custom item can't be ordered with zero personalization data (54-necklace black-hole).
  function enableAddButton(root) {
    var f = root.closest("form"); if (!f) return;
    f.querySelectorAll('[name="add"][data-po-gate]').forEach(function (b) { b.disabled = false; });
  }
  function mount(root) {
    if (root[MOUNTED]) return; root[MOUNTED] = true;
    root._currency = root.dataset.currency || "$";
    var cfgEl = root.querySelector(".ifshe-po-config");
    var fields = [];
    try { fields = JSON.parse(cfgEl ? cfgEl.textContent : (root.dataset.config || "[]")); }
    catch (e) { console.warn("[ifshe-po] bad config JSON", e); return; }
    root._poFields = fields;
    if (!fields.length) { enableAddButton(root); return; }   // no options to enforce -> ungate

    var fieldsWrap = el("div", { class: "ifshe-po__fields" });
    // group consecutive fields sharing the same `group` into one card (Name + Birthstone per heart)
    var curGroup = null, curWrap = null;
    fields.forEach(function (f) {
      if (f.group) {
        if (f.group !== curGroup) {
          curGroup = f.group;
          curWrap = el("div", { class: "ifshe-po__group" });
          if (f.group_label) curWrap.appendChild(el("div", { class: "ifshe-po__group-title", text: f.group_label }));
          fieldsWrap.appendChild(curWrap);
        }
        curWrap.appendChild(renderField(f, root));
      } else {
        curGroup = null; curWrap = null;
        fieldsWrap.appendChild(renderField(f, root));
      }
    });

    var hasUpcharge = fields.some(function (f) { return (f.options || []).some(function (o) { return o.upcharge; }); });
    var pricing = el("div", { class: "ifshe-po__pricing" });
    if (hasUpcharge) {
      pricing.appendChild(el("div", { class: "ifshe-po__pricing-row" }, [el("span", { text: persWord(root) }), el("span", { class: "ifshe-po__up-amt", text: money(0, root._currency) })]));
      pricing.appendChild(el("div", { class: "ifshe-po__pricing-row ifshe-po__pricing-row--total" }, [el("span", { text: "Total" }), el("span", { class: "ifshe-po__total-amt", text: money(root.dataset.basePrice || 0, root._currency) })]));
    }
    root.appendChild(el("input", { type: "hidden", name: "properties[_options_price]", value: "0" }));
    if (cfgEl) cfgEl.style.display = "none";

    // collapsible personalization panel: clean page until the shopper opts in,
    // and they cannot add to cart without opening + completing it
    if (root.dataset.collapsible !== "false") {
      root.classList.add("is-collapsed");
      var toggle = el("button", { type: "button", class: "ifshe-po__toggle", "aria-expanded": "false" },
        [el("span", { class: "ifshe-po__toggle-txt", text: root.dataset.toggleOpen || ("Add " + persWord(root)) })]);
      toggle.addEventListener("click", function () {
        var collapsed = root.classList.toggle("is-collapsed");
        toggle.setAttribute("aria-expanded", String(!collapsed));
        toggle.querySelector(".ifshe-po__toggle-txt").textContent = collapsed
          ? (root.dataset.toggleOpen || ("Add " + persWord(root)))
          : (root.dataset.toggleClose || ("Remove " + persWord(root)));
        var nt = root.querySelector(".ifshe-po__notice"); if (nt) nt.style.display = "none";
      });
      root.appendChild(toggle);
      root.appendChild(el("div", { class: "ifshe-po__notice", role: "alert" }));
    }
    root.appendChild(fieldsWrap); root.appendChild(pricing);

    applyConditions(root, fields);
    root.querySelectorAll(".ifshe-po__editor").forEach(setupPhotoEditor);
    setupValidation(root);
    root.addEventListener("change", function () { recalc(root); });
    recalc(root);

    // OE-01: ungate the add button now the engine has rendered. Re-apply on theme re-renders too
    // (some products re-render the ATC container on variant change, which would restore disabled).
    enableAddButton(root);
    var gateForm = root.closest("form");
    if (gateForm && window.MutationObserver) {
      new MutationObserver(function () { enableAddButton(root); }).observe(gateForm, { childList: true, subtree: true });
    }
  }

  function init() { document.querySelectorAll(".ifshe-po[data-ifshe-options]").forEach(mount); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  window.IfsheProductOptions = { mount: mount, init: init };
})();
